import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = (props) => {
  const { authorized, unauthorizedRedirect = '/login', ...rest } = props;

  if (authorized) {
    return <Route {...rest} />;
  }

  return <Redirect to={unauthorizedRedirect} />;
}

export default ProtectedRoute;
